import {useEffect, useState} from "react";

export const useFetchOnce = (callback,payload) => {
    const [isRun, setIsRun] = useState(false)
    const [data, setData] = useState([])
    useEffect(() => {
        if (!isRun) {
            callback(payload).then(({data}) => {
                setData(data)
            })
            setIsRun(true)
        }
    }, [callback, isRun, setIsRun, payload])
    return data;
}